import React, { useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { useForm } from "react-hook-form";
import ActionButton from "../Common/Components/Button";
import Input from "../Common/Components/InputField";
import { updatePassword } from "../apiSection/apiUrlConstent";
import Loading from "../Common/Components/Loading";
import { logOut } from "../apiSection/util";
import { ShowAlert } from "../Common/Components/Alert";
import service from "../apiSection/service";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { loginauth } from "../Common/ReduxStore/UserStore";
import { addCookies } from "../apiSection/util";


export default function SetPassword(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,

    watch,

    formState: { errors },
  } = useForm();

  const handleChangePassword = (data) => {
    
    const postData = {
      old_password: data.oldPassword,
      password: data.newpassword,
      confirm_password: data.conformPassword,
      token:props?.userData?.token
    };
    let action_method = service.create;
    if(props.loaded_from =="LOGIN" && props?.userData){
      postData["token"] = props?.userData?.token;
      action_method = service.updatePassword;
    }
    setLoading(true);
    action_method(updatePassword, postData)
      .then((res) => {

        if(props.loaded_from =="LOGIN" && props?.userData){ 
           dispatch(loginauth(props?.userData));
           localStorage.setItem("userId", props?.userData?.role_id);
           addCookies(props?.userData?.token);
        }
        setLoading(false);

        ShowAlert({
          icon: "success",
          text: res.data.message,
          width: "400px",
          confirmAction: () => {
            props.Redirectpath("/dashboard");
          },
        });
      })
      .catch((error) => {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: error?.response?.data?.message,
          width: "400px",
        });
      });
  };

  const handlePasswordIcon = (event) => {
    setShowPassword(event);
  };
  const handlePasswordIconNew = (event) => {
    setShowConfirmPassword(event);
  };

  return (
    <div>
      
      <Loading open={loading} />
      <Typography variant="h6" component="h6">
        {props.newPassword ? "Update Password" : "Set Password"}
      </Typography>
      <div style={{ padding: "10px 0px" }}>
        <Input
          name="oldPassword"
          type={showPassword ? "text" : "password"}
          id="newpassword"
          label="Old Password"
          borderRadius="8px"
          border="none"
          backgroundColor="white"
          maxLength={16}
          color="#707EAE"
          visibilityIcon
          visibilityIconColor="#0FA5D8"
          placeholder="Old Password"
          required={true}
          hanldeshowPassword={handlePasswordIcon}
          inputRef={register("oldPassword", {
            required: "Old Password is Required",
          })}
        />

        <div>
          {errors.oldPassword && errors.oldPassword.type === "required" && (
            <ErrorMessage message="Required !!" />
          )}
        </div>
      </div>
      <div style={{ padding: "10px 0px" }}>
        <Input
          name="newpassword"
          type={showPassword ? "text" : "password"}
          id="newpassword"
          label="New Password"
          borderRadius="8px"
          border="none"
          backgroundColor="white"
          maxLength={16}
          color="#707EAE"
          visibilityIcon
          visibilityIconColor="#0FA5D8"
          placeholder="New Password"
          required={true}
          hanldeshowPassword={handlePasswordIcon}
          inputRef={register("newpassword", {
            required: "New Password is Required",
          })}
        />

        <div>
          {errors.newpassword && errors.newpassword.type === "required" && (
            <ErrorMessage message="Required !!" />
          )}
        </div>
      </div>
      <div style={{ padding: "10px 0px" }}>
        <Input
          name="conformPassword"
          type={showConfirmPassword ? "text" : "password"}
          id="conformPassword"
          label="Confirm New Password"
          borderRadius="8px"
          maxLength={15}
          minLength={10}
          visibilityIcon
          border="none"
          backgroundColor="white"
          color="#707EAE"
          required={true}
          visibilityIconColor="#0FA5D8"
          hanldeshowPassword={handlePasswordIconNew}
          placeholder="Confirm New Password"
          inputRef={register("conformPassword", {
            required: "Required !!!",

            validate: (value) =>
              value === watch("newpassword") || "Password do not match",
          })}
        />

        {errors.conformPassword && (
          <ErrorMessage message={errors.conformPassword.message} />
        )}
      </div>
      <div>
        <div>
          <ActionButton
            backgroundColor="rgb(15, 165, 217)"
            color="white"
            buttonText="Update Password"
            fullWidth={true}
            handleSubmit={handleSubmit(handleChangePassword)}
          />
        </div>
      </div>
    </div>
  );
}
